import React, { useState } from 'react';
import {
    FormCheckboxGroup,
    FormTextInput
} from '../../../features/auto-form';
import REFERRAL_SOURCE_OPTIONS from '../config/data/referral-source-options.json';

const ReferralSource = () => {
    const [displayOther, setDisplayOther] = useState(false);

    const handleReferralSourceChange = () => {
        if (document.querySelector('input[id="request.referral.source.other"]').checked) {
            setDisplayOther(true);
        } else {
            setDisplayOther(false);
        }
    }

    return (
        <div className="container request-section">
            <div className="row">
                <div className="col col-12">
                    <FormCheckboxGroup
                        name="request.referral.source"
                        languagesection="form.referralSource"
                        options={REFERRAL_SOURCE_OPTIONS}
                        onChange={handleReferralSourceChange}
                        required
                    />
                </div>
            </div>
            {displayOther &&
                <div className="row">
                    <div className="col col-12-col-md-6 col-sm-4">
                        <FormTextInput
                            label="Other:"
                            name="request.referral.other"
                            placeholder="Other"
                            required
                        />
                    </div>
                </div>
            }
        </div>
    )

}

export default ReferralSource;